$(document).ready(() => {
	function debounce(func, delay) {
		let debounceTimer;
		return function () {
			const context = this;
			const args = arguments;
			clearTimeout(debounceTimer);
			debounceTimer = setTimeout(() => func.apply(context, args), delay);
		};
	}

	$('.scroller-js').each(function () {
		const scroller = $(this).find('.scroller');
		const scrollArea = scroller.find('.scroll-area');
		const prevButton = scroller.find('.prev');
		const nextButton = scroller.find('.next');
		const bulletsContainer = $(this).find('.scroller__bullets');
		let autoplayInterval;
		let currentStep = 0;
		let userInteracted = false;
		// let userInteractionTimeout;

		const items = scrollArea.children();
		const itemCount = items.length;
		const moveItems = parseInt(scrollArea.attr('data-move-items')) || 1;
		const stepCount = Math.floor(itemCount / moveItems);

		// Generate bullets based on step count
		bulletsContainer.empty();
		for (let i = 0; i < stepCount; i++) {
			bulletsContainer.append('<button class="scroller__bullet"></button>');
		}
		const bullets = bulletsContainer.find('.scroller__bullet');

		const calculateItemWidth = () => {
			const itemWidth = items.first().outerWidth();
			const gapSize = parseInt(getComputedStyle(scrollArea[0]).getPropertyValue('--scroller-gap'));
			return itemWidth + gapSize;
		};

		const scrollDuration = 400;
		const autoplayDelay = parseInt(scroller.attr('data-autoplay')) || 0;

		const updateActiveItem = () => {
			items.removeClass('active');
			bullets.removeClass('scroller__bullet--active');

			const startIndex = currentStep * moveItems;
			const endIndex = Math.min(startIndex + moveItems, itemCount);
			for (let i = startIndex; i < endIndex; i++) {
				items.eq(i).addClass('active');
			}
			bullets.eq(currentStep).addClass('scroller__bullet--active');

			scrollArea.find('video').each(function () {
				this.pause();
			});

			const activeVideos = items.slice(startIndex, endIndex).find('video');
			activeVideos.each(function () {
				this.play();
			});
		};

		const scrollToStep = (step, instant = false) => {
			scrollArea.removeClass('scroll-area--snap');
			const itemWidth = calculateItemWidth();
			const scrollPosition = step * moveItems * itemWidth;

			if (instant) {
				scrollArea.scrollLeft(scrollPosition);
				scrollArea.addClass('scroll-area--snap');
				updateActiveItem();
			} else {
				scrollArea.animate(
					{
						scrollLeft: scrollPosition
					},
					scrollDuration,
					function () {
						scrollArea.addClass('scroll-area--snap');
						updateActiveItem();
					}
				);
			}
		};

		const handleScroll = direction => {
			const maxStep = stepCount - 1;

			if (direction > 0) {
				if (currentStep >= maxStep) {
					currentStep = 0;
					scrollToStep(maxStep, true);
					setTimeout(() => {
						scrollToStep(0, true);
					}, 50);
				} else {
					currentStep = Math.min(currentStep + 1, maxStep);
					scrollToStep(currentStep);
				}
			} else {
				if (currentStep <= 0) {
					currentStep = maxStep;
					scrollToStep(maxStep, true);
					setTimeout(() => {
						scrollToStep(currentStep, true);
					}, 50);
				} else {
					currentStep = Math.max(currentStep - 1, 0);
					scrollToStep(currentStep);
				}
			}
		};

		const startAutoplay = () => {
			if (autoplayDelay > 0 && !userInteracted) {
				stopAutoplay();
				autoplayInterval = setInterval(() => {
					if (!userInteracted) {
						handleScroll(1);
					}
				}, autoplayDelay);
			}
		};

		const stopAutoplay = () => {
			clearInterval(autoplayInterval);
		};

		const handleUserInteraction = () => {
			userInteracted = true;
			stopAutoplay();
		};

		prevButton.on('click', () => {
			handleScroll(-1);
			handleUserInteraction();
		});

		nextButton.on('click', () => {
			handleScroll(1);
			handleUserInteraction();
		});

		bullets.on('click', function () {
			const bulletIndex = $(this).index();
			currentStep = bulletIndex;
			scrollToStep(currentStep);
			handleUserInteraction();
		});

		scrollArea.on('mousedown touchstart', handleUserInteraction);

		if (autoplayDelay > 0) {
			scrollArea.on('mouseenter', stopAutoplay);
			scrollArea.on('mouseleave', () => {
				if (!userInteracted) {
					startAutoplay();
					handleScroll(1);
				}
			});
		}

		updateActiveItem();

		scrollArea.on(
			'scroll',
			debounce(() => {
				const itemWidth = calculateItemWidth();
				currentStep = Math.round(scrollArea.scrollLeft() / (itemWidth * moveItems));
				updateActiveItem();
			}, 100)
		);

		const hasContentAgreement = () => {
			return document.cookie.includes('adult_content_agreement');
		};

		if (hasContentAgreement()) {
			startAutoplay();
		}

		$(document).on('playHpSlider', () => {
			startAutoplay();
		});
	});
});
